// config relevant to creation of youtube player to be used in the editor
var playerConfig = {
  modestBranding: false,
  controls: true,
  info: true,
  related: true
}

export default playerConfig
